import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "achievement-popups-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_achievement_popup = _resolveComponent("achievement-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, { name: "popup-list" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.popups, (popup) => {
          return (_openBlock(), _createBlock(_component_achievement_popup, {
            key: popup.id,
            achievementIDs: popup.achievementIDs,
            stickerIDs: popup.stickerIDs,
            onClose: ($event: any) => (_ctx.closePopup(popup.id))
          }, null, 8, ["achievementIDs", "stickerIDs", "onClose"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}